/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Groupings for the settings in the Stammdaten service
 */
export enum EnumStammdatenSettingGroups {
    /**
     * No group
     */
    NotDefined = 0,
    /**
     * Settings that affect the behavior of counters
     */
    Counters = 1,
    /**
     * Settings that affect the behavior of print options
     */
    PrintOptions = 2,
    /**
     * Settings that affect the behavior of payment terms
     */
    PaymentTerms = 3,
}
